module.exports = __webpack_public_path__ + "static/img/new-6.d10e7c91.jpg";